<template>
    <div>
        <b-card-code
                title="HORINFO adatfrissítés"
        >
            <b-overlay
                    :show="loading"
                    spinner-variant="primary"
                    spinner-type="grow"
                    rounded="sm"
            >
                <b-alert
                        variant="primary"
                        class="mb-2"
                        :show="true"
                >
                    <div class="alert-body">
                        <feather-icon
                                icon="InfoIcon"
                                class="mr-50"
                        />
                        A HORINFO szakrendszer víztér adatainak átvétele rendszeres időközönként megtörténik. Ha szeretné most elvégezni a frissítést, akkor az adatfrissítés gombbal elindíthatja!<br>
                        <b-button
                                class="mt-2"
                                size="sm"
                                variant="primary"
                                @click.stop="updateHorInfo"
                        >Adatfrissítés
                        </b-button>

                        <p class="mt-2" v-if="lastSync">Utolsó frissítés időpontja: {{ dateHelper.formatBackendTimestamp(lastSync, 'YYYY-MM-DD HH:mm') }}</p>
                    </div>
                </b-alert>
            </b-overlay>
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
    BRow, BCol, BButton, BOverlay, BAlert,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import dateHelper from "@/libs/helper/dateHelper";

export default {
    components: {
        BAlert,
        BCardCode,
        BRow,
        BCol,
        BButton,
        BOverlay,
        cancelAndGOTOPreviousPage,
    },
    data() {
        return {
            role: 'water',
            loading: false,
            lastSync: '',
            required,
            dateHelper,
        }
    },
    created() {
        this.getLastRun()
    },
    methods: {
        getLastRun() {
            this.loading = true
            this.$store.dispatch('getLastHorInfoSync').then(response => {
                this.lastSync = response.data.lastRun
            }).finally(() => {
                this.loading = false
            })
        },
        updateHorInfo() {
            this.loading = true

            this.$store.dispatch('syncHorInfo').then(() => {
                this.$helpers.showSuccessToast('A HORINFO szinkronizáció sikeres volt.')
            }).catch(() => {
                this.$helpers.showErrorToast('A HORINFO szinkronizáció nem sikerült.')
            }).finally(() => {
                this.getLastRun()
                this.loading = false
            })
        }
    }
}
</script>
